const catalogue = [
  {
    "id": "Poire",
    "name": "Poire",
    "materials": [
      {
        "id": "Polyster",
        "name": "Polyster",
        "sizes": [
          {
            "id": "XL",
            "name": "XL",
            "colors": [
              {
                "id": "Bleu Ciel Bleu Clair.png",
                "name": "Bleu Ciel Bleu Clair",
                "image": "/catalogue/Poire/Polyster/XL/Bleu%20Ciel%20Bleu%20Clair.png"
              },
              {
                "id": "Bleu Marine.png",
                "name": "Bleu Marine",
                "image": "/catalogue/Poire/Polyster/XL/Bleu%20Marine.png"
              },
              {
                "id": "Bleu Turquoise.png",
                "name": "Bleu Turquoise",
                "image": "/catalogue/Poire/Polyster/XL/Bleu%20Turquoise.png"
              },
              {
                "id": "Brun Marron Foncé.png",
                "name": "Brun Marron Foncé",
                "image": "/catalogue/Poire/Polyster/XL/Brun%20Marron%20Fonc%C3%A9.png"
              },
              {
                "id": "Gris Foncé.png",
                "name": "Gris Foncé",
                "image": "/catalogue/Poire/Polyster/XL/Gris%20Fonc%C3%A9.png"
              },
              {
                "id": "Jaune Moutarde.png",
                "name": "Jaune Moutarde",
                "image": "/catalogue/Poire/Polyster/XL/Jaune%20Moutarde.png"
              },
              {
                "id": "Noir.png",
                "name": "Noir",
                "image": "/catalogue/Poire/Polyster/XL/Noir.png"
              },
              {
                "id": "Orange.png",
                "name": "Orange",
                "image": "/catalogue/Poire/Polyster/XL/Orange.png"
              },
              {
                "id": "Rose Fuchsia.png",
                "name": "Rose Fuchsia",
                "image": "/catalogue/Poire/Polyster/XL/Rose%20Fuchsia.png"
              },
              {
                "id": "Rouge Bordeaux  Bourgogne.png",
                "name": "Rouge Bordeaux Bourgogne",
                "image": "/catalogue/Poire/Polyster/XL/Rouge%20Bordeaux%20%20Bourgogne.png"
              },
              {
                "id": "Rouge Vif.png",
                "name": "Rouge Vif",
                "image": "/catalogue/Poire/Polyster/XL/Rouge%20Vif.png"
              },
              {
                "id": "Vert d_eau Vert Menthe.png",
                "name": "Vert D Eau Vert Menthe",
                "image": "/catalogue/Poire/Polyster/XL/Vert%20d_eau%20Vert%20Menthe.png"
              },
              {
                "id": "Vert sapain Vert Foncé.png",
                "name": "Vert Sapain Vert Foncé",
                "image": "/catalogue/Poire/Polyster/XL/Vert%20sapain%20Vert%20Fonc%C3%A9.png"
              },
              {
                "id": "Vieux Rose Prune.png",
                "name": "Vieux Rose Prune",
                "image": "/catalogue/Poire/Polyster/XL/Vieux%20Rose%20Prune.png"
              },
              {
                "id": "Violet Foncé.png",
                "name": "Violet Foncé",
                "image": "/catalogue/Poire/Polyster/XL/Violet%20Fonc%C3%A9.png"
              }
            ]
          },
          {
            "id": "XXL",
            "name": "XXL",
            "colors": [
              {
                "id": "Bleu Ciel Bleu Clair.png",
                "name": "Bleu Ciel Bleu Clair",
                "image": "/catalogue/Poire/Polyster/XXL/Bleu%20Ciel%20Bleu%20Clair.png"
              },
              {
                "id": "Bleu Marine.png",
                "name": "Bleu Marine",
                "image": "/catalogue/Poire/Polyster/XXL/Bleu%20Marine.png"
              },
              {
                "id": "Bleu Turquoise.png",
                "name": "Bleu Turquoise",
                "image": "/catalogue/Poire/Polyster/XXL/Bleu%20Turquoise.png"
              },
              {
                "id": "Brun Marron Foncé.png",
                "name": "Brun Marron Foncé",
                "image": "/catalogue/Poire/Polyster/XXL/Brun%20Marron%20Fonc%C3%A9.png"
              },
              {
                "id": "Gris Foncé.png",
                "name": "Gris Foncé",
                "image": "/catalogue/Poire/Polyster/XXL/Gris%20Fonc%C3%A9.png"
              },
              {
                "id": "Jaune Moutarde.png",
                "name": "Jaune Moutarde",
                "image": "/catalogue/Poire/Polyster/XXL/Jaune%20Moutarde.png"
              },
              {
                "id": "Noir.png",
                "name": "Noir",
                "image": "/catalogue/Poire/Polyster/XXL/Noir.png"
              },
              {
                "id": "Orange.png",
                "name": "Orange",
                "image": "/catalogue/Poire/Polyster/XXL/Orange.png"
              },
              {
                "id": "Rose Fuchsia.png",
                "name": "Rose Fuchsia",
                "image": "/catalogue/Poire/Polyster/XXL/Rose%20Fuchsia.png"
              },
              {
                "id": "Rouge Bordeaux  Bourgogne.png",
                "name": "Rouge Bordeaux Bourgogne",
                "image": "/catalogue/Poire/Polyster/XXL/Rouge%20Bordeaux%20%20Bourgogne.png"
              },
              {
                "id": "Rouge Vif.png",
                "name": "Rouge Vif",
                "image": "/catalogue/Poire/Polyster/XXL/Rouge%20Vif.png"
              },
              {
                "id": "Vert d_eau Vert Menthe.png",
                "name": "Vert D Eau Vert Menthe",
                "image": "/catalogue/Poire/Polyster/XXL/Vert%20d_eau%20Vert%20Menthe.png"
              },
              {
                "id": "Vert sapain Vert Foncé.png",
                "name": "Vert Sapain Vert Foncé",
                "image": "/catalogue/Poire/Polyster/XXL/Vert%20sapain%20Vert%20Fonc%C3%A9.png"
              },
              {
                "id": "Vieux Rose Prune.png",
                "name": "Vieux Rose Prune",
                "image": "/catalogue/Poire/Polyster/XXL/Vieux%20Rose%20Prune.png"
              },
              {
                "id": "Violet Foncé.png",
                "name": "Violet Foncé",
                "image": "/catalogue/Poire/Polyster/XXL/Violet%20Fonc%C3%A9.png"
              }
            ]
          }
        ]
      },
      {
        "id": "Similicuir",
        "name": "Similicuir",
        "sizes": [
          {
            "id": "XL",
            "name": "XL",
            "colors": [
              {
                "id": "Beige.jpg",
                "name": "Beige",
                "image": "/catalogue/Poire/Similicuir/XL/Beige.jpg"
              },
              {
                "id": "Bleu.jpg",
                "name": "Bleu",
                "image": "/catalogue/Poire/Similicuir/XL/Bleu.jpg"
              },
              {
                "id": "Gris.jpg",
                "name": "Gris",
                "image": "/catalogue/Poire/Similicuir/XL/Gris.jpg"
              },
              {
                "id": "Jaune.jpg",
                "name": "Jaune",
                "image": "/catalogue/Poire/Similicuir/XL/Jaune.jpg"
              },
              {
                "id": "Marron.jpg",
                "name": "Marron",
                "image": "/catalogue/Poire/Similicuir/XL/Marron.jpg"
              },
              {
                "id": "noir.jpg",
                "name": "Noir",
                "image": "/catalogue/Poire/Similicuir/XL/noir.jpg"
              },
              {
                "id": "Rouge.jpg",
                "name": "Rouge",
                "image": "/catalogue/Poire/Similicuir/XL/Rouge.jpg"
              },
              {
                "id": "Vert Pistache.jpg",
                "name": "Vert Pistache",
                "image": "/catalogue/Poire/Similicuir/XL/Vert%20Pistache.jpg"
              },
              {
                "id": "Vert.jpg",
                "name": "Vert",
                "image": "/catalogue/Poire/Similicuir/XL/Vert.jpg"
              },
              {
                "id": "Violet.jpg",
                "name": "Violet",
                "image": "/catalogue/Poire/Similicuir/XL/Violet.jpg"
              }
            ]
          },
          {
            "id": "XXL",
            "name": "XXL",
            "colors": [
              {
                "id": "Beige.jpg",
                "name": "Beige",
                "image": "/catalogue/Poire/Similicuir/XXL/Beige.jpg"
              },
              {
                "id": "Bleu.jpg",
                "name": "Bleu",
                "image": "/catalogue/Poire/Similicuir/XXL/Bleu.jpg"
              },
              {
                "id": "Gris.jpg",
                "name": "Gris",
                "image": "/catalogue/Poire/Similicuir/XXL/Gris.jpg"
              },
              {
                "id": "Jaune.jpg",
                "name": "Jaune",
                "image": "/catalogue/Poire/Similicuir/XXL/Jaune.jpg"
              },
              {
                "id": "Marron.jpg",
                "name": "Marron",
                "image": "/catalogue/Poire/Similicuir/XXL/Marron.jpg"
              },
              {
                "id": "noir.jpg",
                "name": "Noir",
                "image": "/catalogue/Poire/Similicuir/XXL/noir.jpg"
              },
              {
                "id": "Rouge.jpg",
                "name": "Rouge",
                "image": "/catalogue/Poire/Similicuir/XXL/Rouge.jpg"
              },
              {
                "id": "Vert Pistache.jpg",
                "name": "Vert Pistache",
                "image": "/catalogue/Poire/Similicuir/XXL/Vert%20Pistache.jpg"
              },
              {
                "id": "Vert.jpg",
                "name": "Vert",
                "image": "/catalogue/Poire/Similicuir/XXL/Vert.jpg"
              },
              {
                "id": "Violet.jpg",
                "name": "Violet",
                "image": "/catalogue/Poire/Similicuir/XXL/Violet.jpg"
              }
            ]
          }
        ]
      },
      {
        "id": "Velour",
        "name": "Velour",
        "sizes": [
          {
            "id": "XL",
            "name": "XL",
            "colors": [
              {
                "id": "Beige Claire.png",
                "name": "Beige Claire",
                "image": "/catalogue/Poire/Velour/XL/Beige%20Claire.png"
              },
              {
                "id": "Blanc cassé  Crème.png",
                "name": "Blanc Cassé CrèMe",
                "image": "/catalogue/Poire/Velour/XL/Blanc%20cass%C3%A9%20%20Cr%C3%A8me.png"
              },
              {
                "id": "Blanc Pur.png",
                "name": "Blanc Pur",
                "image": "/catalogue/Poire/Velour/XL/Blanc%20Pur.png"
              },
              {
                "id": "Bleu Ardoise.png",
                "name": "Bleu Ardoise",
                "image": "/catalogue/Poire/Velour/XL/Bleu%20Ardoise.png"
              },
              {
                "id": "Bleu canard moyen.png",
                "name": "Bleu Canard Moyen",
                "image": "/catalogue/Poire/Velour/XL/Bleu%20canard%20moyen.png"
              },
              {
                "id": "Bleu denim  Bleu moyen.png",
                "name": "Bleu Denim Bleu Moyen",
                "image": "/catalogue/Poire/Velour/XL/Bleu%20denim%20%20Bleu%20moyen.png"
              },
              {
                "id": "Bleu Glace.png",
                "name": "Bleu Glace",
                "image": "/catalogue/Poire/Velour/XL/Bleu%20Glace.png"
              },
              {
                "id": "Bleu Jean.png",
                "name": "Bleu Jean",
                "image": "/catalogue/Poire/Velour/XL/Bleu%20Jean.png"
              },
              {
                "id": "Bleu Marine.png",
                "name": "Bleu Marine",
                "image": "/catalogue/Poire/Velour/XL/Bleu%20Marine.png"
              },
              {
                "id": "Bleu Nuit.png",
                "name": "Bleu Nuit",
                "image": "/catalogue/Poire/Velour/XL/Bleu%20Nuit.png"
              },
              {
                "id": "Bleu Pastel Bleu Céladon.png",
                "name": "Bleu Pastel Bleu CéLadon",
                "image": "/catalogue/Poire/Velour/XL/Bleu%20Pastel%20Bleu%20C%C3%A9ladon.png"
              },
              {
                "id": "Bleu pétrole clair.png",
                "name": "Bleu PéTrole Clair",
                "image": "/catalogue/Poire/Velour/XL/Bleu%20p%C3%A9trole%20clair.png"
              },
              {
                "id": "Bleu pétrole foncé.png",
                "name": "Bleu PéTrole Foncé",
                "image": "/catalogue/Poire/Velour/XL/Bleu%20p%C3%A9trole%20fonc%C3%A9.png"
              },
              {
                "id": "Bleu Roi Bleu Electrique.png",
                "name": "Bleu Roi Bleu Electrique",
                "image": "/catalogue/Poire/Velour/XL/Bleu%20Roi%20Bleu%20Electrique.png"
              },
              {
                "id": "Bleu Turquoise Clair Bleu D_eau.png",
                "name": "Bleu Turquoise Clair Bleu D Eau",
                "image": "/catalogue/Poire/Velour/XL/Bleu%20Turquoise%20Clair%20Bleu%20D_eau.png"
              },
              {
                "id": "Bois de Rose.png",
                "name": "Bois De Rose",
                "image": "/catalogue/Poire/Velour/XL/Bois%20de%20Rose.png"
              },
              {
                "id": "Bordeaux Rouge Fromboise.jpg",
                "name": "Bordeaux Rouge Fromboise",
                "image": "/catalogue/Poire/Velour/XL/Bordeaux%20Rouge%20Fromboise.jpg"
              },
              {
                "id": "Brun chocolat Marron Foncé.png",
                "name": "Brun Chocolat Marron Foncé",
                "image": "/catalogue/Poire/Velour/XL/Brun%20chocolat%20Marron%20Fonc%C3%A9.png"
              },
              {
                "id": "Gris anthracite.png",
                "name": "Gris Anthracite",
                "image": "/catalogue/Poire/Velour/XL/Gris%20anthracite.png"
              },
              {
                "id": "Gris Clair.png",
                "name": "Gris Clair",
                "image": "/catalogue/Poire/Velour/XL/Gris%20Clair.png"
              },
              {
                "id": "Gris Moyen.png",
                "name": "Gris Moyen",
                "image": "/catalogue/Poire/Velour/XL/Gris%20Moyen.png"
              },
              {
                "id": "Gris perle.png",
                "name": "Gris Perle",
                "image": "/catalogue/Poire/Velour/XL/Gris%20perle.png"
              },
              {
                "id": "Jaune d_or Tournesol.png",
                "name": "Jaune D Or Tournesol",
                "image": "/catalogue/Poire/Velour/XL/Jaune%20d_or%20Tournesol.png"
              },
              {
                "id": "Jaune Moutarde Ocre.png",
                "name": "Jaune Moutarde Ocre",
                "image": "/catalogue/Poire/Velour/XL/Jaune%20Moutarde%20Ocre.png"
              },
              {
                "id": "Jaune Paille Jaune pastel.png",
                "name": "Jaune Paille Jaune Pastel",
                "image": "/catalogue/Poire/Velour/XL/Jaune%20Paille%20Jaune%20pastel.png"
              },
              {
                "id": "Marron glacé Taupe foncé.png",
                "name": "Marron Glacé Taupe Foncé",
                "image": "/catalogue/Poire/Velour/XL/Marron%20glac%C3%A9%20Taupe%20fonc%C3%A9.png"
              },
              {
                "id": "Noir.png",
                "name": "Noir",
                "image": "/catalogue/Poire/Velour/XL/Noir.png"
              },
              {
                "id": "Prune foncé.png",
                "name": "Prune Foncé",
                "image": "/catalogue/Poire/Velour/XL/Prune%20fonc%C3%A9.png"
              },
              {
                "id": "Rose Dragée Très Clair.jpg",
                "name": "Rose DragéE TrèS Clair",
                "image": "/catalogue/Poire/Velour/XL/Rose%20Drag%C3%A9e%20Tr%C3%A8s%20Clair.jpg"
              },
              {
                "id": "Rose fuchsia.png",
                "name": "Rose Fuchsia",
                "image": "/catalogue/Poire/Velour/XL/Rose%20fuchsia.png"
              },
              {
                "id": "Rose poudré.png",
                "name": "Rose Poudré",
                "image": "/catalogue/Poire/Velour/XL/Rose%20poudr%C3%A9.png"
              },
              {
                "id": "Rouge Vif Cerise.png",
                "name": "Rouge Vif Cerise",
                "image": "/catalogue/Poire/Velour/XL/Rouge%20Vif%20Cerise.png"
              },
              {
                "id": "Taupe clair  Greige.png",
                "name": "Taupe Clair Greige",
                "image": "/catalogue/Poire/Velour/XL/Taupe%20clair%20%20Greige.png"
              },
              {
                "id": "Terracotta Brique.png",
                "name": "Terracotta Brique",
                "image": "/catalogue/Poire/Velour/XL/Terracotta%20Brique.png"
              },
              {
                "id": "Vert Canard Vert Petrole.png",
                "name": "Vert Canard Vert Petrole",
                "image": "/catalogue/Poire/Velour/XL/Vert%20Canard%20Vert%20Petrole.png"
              },
              {
                "id": "Vert Foret.png",
                "name": "Vert Foret",
                "image": "/catalogue/Poire/Velour/XL/Vert%20Foret.png"
              },
              {
                "id": "Vert Olive Vert Sauge.png",
                "name": "Vert Olive Vert Sauge",
                "image": "/catalogue/Poire/Velour/XL/Vert%20Olive%20Vert%20Sauge.png"
              },
              {
                "id": "Vert sauge poudré.png",
                "name": "Vert Sauge Poudré",
                "image": "/catalogue/Poire/Velour/XL/Vert%20sauge%20poudr%C3%A9.png"
              },
              {
                "id": "Vieux Rose Rose Poudré.png",
                "name": "Vieux Rose Rose Poudré",
                "image": "/catalogue/Poire/Velour/XL/Vieux%20Rose%20Rose%20Poudr%C3%A9.png"
              },
              {
                "id": "Violet Pourpre.png",
                "name": "Violet Pourpre",
                "image": "/catalogue/Poire/Velour/XL/Violet%20Pourpre.png"
              }
            ]
          },
          {
            "id": "XXL",
            "name": "XXL",
            "colors": [
              {
                "id": "Beige Claire.png",
                "name": "Beige Claire",
                "image": "/catalogue/Poire/Velour/XXL/Beige%20Claire.png"
              },
              {
                "id": "Blanc cassé  Crème.png",
                "name": "Blanc Cassé CrèMe",
                "image": "/catalogue/Poire/Velour/XXL/Blanc%20cass%C3%A9%20%20Cr%C3%A8me.png"
              },
              {
                "id": "Blanc Pur.png",
                "name": "Blanc Pur",
                "image": "/catalogue/Poire/Velour/XXL/Blanc%20Pur.png"
              },
              {
                "id": "Bleu Ardoise.png",
                "name": "Bleu Ardoise",
                "image": "/catalogue/Poire/Velour/XXL/Bleu%20Ardoise.png"
              },
              {
                "id": "Bleu canard moyen.png",
                "name": "Bleu Canard Moyen",
                "image": "/catalogue/Poire/Velour/XXL/Bleu%20canard%20moyen.png"
              },
              {
                "id": "Bleu denim  Bleu moyen.png",
                "name": "Bleu Denim Bleu Moyen",
                "image": "/catalogue/Poire/Velour/XXL/Bleu%20denim%20%20Bleu%20moyen.png"
              },
              {
                "id": "Bleu Glace.png",
                "name": "Bleu Glace",
                "image": "/catalogue/Poire/Velour/XXL/Bleu%20Glace.png"
              },
              {
                "id": "Bleu Jean.png",
                "name": "Bleu Jean",
                "image": "/catalogue/Poire/Velour/XXL/Bleu%20Jean.png"
              },
              {
                "id": "Bleu Marine.png",
                "name": "Bleu Marine",
                "image": "/catalogue/Poire/Velour/XXL/Bleu%20Marine.png"
              },
              {
                "id": "Bleu Nuit.png",
                "name": "Bleu Nuit",
                "image": "/catalogue/Poire/Velour/XXL/Bleu%20Nuit.png"
              },
              {
                "id": "Bleu Pastel Bleu Céladon.png",
                "name": "Bleu Pastel Bleu CéLadon",
                "image": "/catalogue/Poire/Velour/XXL/Bleu%20Pastel%20Bleu%20C%C3%A9ladon.png"
              },
              {
                "id": "Bleu pétrole clair.png",
                "name": "Bleu PéTrole Clair",
                "image": "/catalogue/Poire/Velour/XXL/Bleu%20p%C3%A9trole%20clair.png"
              },
              {
                "id": "Bleu pétrole foncé.png",
                "name": "Bleu PéTrole Foncé",
                "image": "/catalogue/Poire/Velour/XXL/Bleu%20p%C3%A9trole%20fonc%C3%A9.png"
              },
              {
                "id": "Bleu Roi Bleu Electrique.png",
                "name": "Bleu Roi Bleu Electrique",
                "image": "/catalogue/Poire/Velour/XXL/Bleu%20Roi%20Bleu%20Electrique.png"
              },
              {
                "id": "Bleu Turquoise Clair Bleu D_eau.png",
                "name": "Bleu Turquoise Clair Bleu D Eau",
                "image": "/catalogue/Poire/Velour/XXL/Bleu%20Turquoise%20Clair%20Bleu%20D_eau.png"
              },
              {
                "id": "Bois de Rose.png",
                "name": "Bois De Rose",
                "image": "/catalogue/Poire/Velour/XXL/Bois%20de%20Rose.png"
              },
              {
                "id": "Bordeaux Rouge Fromboise.jpg",
                "name": "Bordeaux Rouge Fromboise",
                "image": "/catalogue/Poire/Velour/XXL/Bordeaux%20Rouge%20Fromboise.jpg"
              },
              {
                "id": "Brun chocolat Marron Foncé.png",
                "name": "Brun Chocolat Marron Foncé",
                "image": "/catalogue/Poire/Velour/XXL/Brun%20chocolat%20Marron%20Fonc%C3%A9.png"
              },
              {
                "id": "Gris anthracite.png",
                "name": "Gris Anthracite",
                "image": "/catalogue/Poire/Velour/XXL/Gris%20anthracite.png"
              },
              {
                "id": "Gris Clair.png",
                "name": "Gris Clair",
                "image": "/catalogue/Poire/Velour/XXL/Gris%20Clair.png"
              },
              {
                "id": "Gris Moyen.png",
                "name": "Gris Moyen",
                "image": "/catalogue/Poire/Velour/XXL/Gris%20Moyen.png"
              },
              {
                "id": "Gris perle.png",
                "name": "Gris Perle",
                "image": "/catalogue/Poire/Velour/XXL/Gris%20perle.png"
              },
              {
                "id": "Jaune d_or Tournesol.png",
                "name": "Jaune D Or Tournesol",
                "image": "/catalogue/Poire/Velour/XXL/Jaune%20d_or%20Tournesol.png"
              },
              {
                "id": "Jaune Moutarde Ocre.png",
                "name": "Jaune Moutarde Ocre",
                "image": "/catalogue/Poire/Velour/XXL/Jaune%20Moutarde%20Ocre.png"
              },
              {
                "id": "Jaune Paille Jaune pastel.png",
                "name": "Jaune Paille Jaune Pastel",
                "image": "/catalogue/Poire/Velour/XXL/Jaune%20Paille%20Jaune%20pastel.png"
              },
              {
                "id": "Marron glacé Taupe foncé.png",
                "name": "Marron Glacé Taupe Foncé",
                "image": "/catalogue/Poire/Velour/XXL/Marron%20glac%C3%A9%20Taupe%20fonc%C3%A9.png"
              },
              {
                "id": "Noir.png",
                "name": "Noir",
                "image": "/catalogue/Poire/Velour/XXL/Noir.png"
              },
              {
                "id": "Prune foncé.png",
                "name": "Prune Foncé",
                "image": "/catalogue/Poire/Velour/XXL/Prune%20fonc%C3%A9.png"
              },
              {
                "id": "Rose Dragée Très Clair.jpg",
                "name": "Rose DragéE TrèS Clair",
                "image": "/catalogue/Poire/Velour/XXL/Rose%20Drag%C3%A9e%20Tr%C3%A8s%20Clair.jpg"
              },
              {
                "id": "Rose fuchsia.png",
                "name": "Rose Fuchsia",
                "image": "/catalogue/Poire/Velour/XXL/Rose%20fuchsia.png"
              },
              {
                "id": "Rose poudré.png",
                "name": "Rose Poudré",
                "image": "/catalogue/Poire/Velour/XXL/Rose%20poudr%C3%A9.png"
              },
              {
                "id": "Rouge Vif Cerise.png",
                "name": "Rouge Vif Cerise",
                "image": "/catalogue/Poire/Velour/XXL/Rouge%20Vif%20Cerise.png"
              },
              {
                "id": "Taupe clair  Greige.png",
                "name": "Taupe Clair Greige",
                "image": "/catalogue/Poire/Velour/XXL/Taupe%20clair%20%20Greige.png"
              },
              {
                "id": "Terracotta Brique.png",
                "name": "Terracotta Brique",
                "image": "/catalogue/Poire/Velour/XXL/Terracotta%20Brique.png"
              },
              {
                "id": "Vert Canard Vert Petrole.png",
                "name": "Vert Canard Vert Petrole",
                "image": "/catalogue/Poire/Velour/XXL/Vert%20Canard%20Vert%20Petrole.png"
              },
              {
                "id": "Vert Foret.png",
                "name": "Vert Foret",
                "image": "/catalogue/Poire/Velour/XXL/Vert%20Foret.png"
              },
              {
                "id": "Vert Olive Vert Sauge.png",
                "name": "Vert Olive Vert Sauge",
                "image": "/catalogue/Poire/Velour/XXL/Vert%20Olive%20Vert%20Sauge.png"
              },
              {
                "id": "Vert sauge poudré.png",
                "name": "Vert Sauge Poudré",
                "image": "/catalogue/Poire/Velour/XXL/Vert%20sauge%20poudr%C3%A9.png"
              },
              {
                "id": "Vieux Rose Rose Poudré.png",
                "name": "Vieux Rose Rose Poudré",
                "image": "/catalogue/Poire/Velour/XXL/Vieux%20Rose%20Rose%20Poudr%C3%A9.png"
              },
              {
                "id": "Violet Pourpre.png",
                "name": "Violet Pourpre",
                "image": "/catalogue/Poire/Velour/XXL/Violet%20Pourpre.png"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "id": "Tabouret",
    "name": "Tabouret",
    "materials": [
      {
        "id": "Similicuir",
        "name": "Similicuir",
        "sizes": [
          {
            "id": "XL",
            "name": "XL",
            "colors": [
              {
                "id": "12f576d8-2b85-44a0-8495-e846e6bc52d0.jpg",
                "name": "12f576d8 2b85 44a0 8495 E846e6bc52d0",
                "image": "/catalogue/Tabouret/Similicuir/XL/12f576d8-2b85-44a0-8495-e846e6bc52d0.jpg"
              },
              {
                "id": "4c817130-2131-45c4-89e7-31bfa074bafb.jpg",
                "name": "4c817130 2131 45c4 89e7 31bfa074bafb",
                "image": "/catalogue/Tabouret/Similicuir/XL/4c817130-2131-45c4-89e7-31bfa074bafb.jpg"
              },
              {
                "id": "595d4232-9324-4288-ae6e-1973628efc13.jpg",
                "name": "595d4232 9324 4288 Ae6e 1973628efc13",
                "image": "/catalogue/Tabouret/Similicuir/XL/595d4232-9324-4288-ae6e-1973628efc13.jpg"
              },
              {
                "id": "93230f16-888b-455e-b5c9-7102009e8343.jpg",
                "name": "93230f16 888b 455e B5c9 7102009e8343",
                "image": "/catalogue/Tabouret/Similicuir/XL/93230f16-888b-455e-b5c9-7102009e8343.jpg"
              },
              {
                "id": "a4071919-5940-4e90-ac38-2a0a30a7a484.jpg",
                "name": "A4071919 5940 4e90 Ac38 2a0a30a7a484",
                "image": "/catalogue/Tabouret/Similicuir/XL/a4071919-5940-4e90-ac38-2a0a30a7a484.jpg"
              },
              {
                "id": "eaa59b4d-94ad-41a7-8747-5d808f901b11.jpg",
                "name": "Eaa59b4d 94ad 41a7 8747 5d808f901b11",
                "image": "/catalogue/Tabouret/Similicuir/XL/eaa59b4d-94ad-41a7-8747-5d808f901b11.jpg"
              },
              {
                "id": "f187b25c-1a51-4ab8-a563-1daecbbfddc6.jpg",
                "name": "F187b25c 1a51 4ab8 A563 1daecbbfddc6",
                "image": "/catalogue/Tabouret/Similicuir/XL/f187b25c-1a51-4ab8-a563-1daecbbfddc6.jpg"
              }
            ]
          },
          {
            "id": "XXL",
            "name": "XXL",
            "colors": [
              {
                "id": "12f576d8-2b85-44a0-8495-e846e6bc52d0.jpg",
                "name": "12f576d8 2b85 44a0 8495 E846e6bc52d0",
                "image": "/catalogue/Tabouret/Similicuir/XXL/12f576d8-2b85-44a0-8495-e846e6bc52d0.jpg"
              },
              {
                "id": "4c817130-2131-45c4-89e7-31bfa074bafb.jpg",
                "name": "4c817130 2131 45c4 89e7 31bfa074bafb",
                "image": "/catalogue/Tabouret/Similicuir/XXL/4c817130-2131-45c4-89e7-31bfa074bafb.jpg"
              },
              {
                "id": "595d4232-9324-4288-ae6e-1973628efc13.jpg",
                "name": "595d4232 9324 4288 Ae6e 1973628efc13",
                "image": "/catalogue/Tabouret/Similicuir/XXL/595d4232-9324-4288-ae6e-1973628efc13.jpg"
              },
              {
                "id": "93230f16-888b-455e-b5c9-7102009e8343.jpg",
                "name": "93230f16 888b 455e B5c9 7102009e8343",
                "image": "/catalogue/Tabouret/Similicuir/XXL/93230f16-888b-455e-b5c9-7102009e8343.jpg"
              },
              {
                "id": "a4071919-5940-4e90-ac38-2a0a30a7a484.jpg",
                "name": "A4071919 5940 4e90 Ac38 2a0a30a7a484",
                "image": "/catalogue/Tabouret/Similicuir/XXL/a4071919-5940-4e90-ac38-2a0a30a7a484.jpg"
              },
              {
                "id": "eaa59b4d-94ad-41a7-8747-5d808f901b11.jpg",
                "name": "Eaa59b4d 94ad 41a7 8747 5d808f901b11",
                "image": "/catalogue/Tabouret/Similicuir/XXL/eaa59b4d-94ad-41a7-8747-5d808f901b11.jpg"
              },
              {
                "id": "f187b25c-1a51-4ab8-a563-1daecbbfddc6.jpg",
                "name": "F187b25c 1a51 4ab8 A563 1daecbbfddc6",
                "image": "/catalogue/Tabouret/Similicuir/XXL/f187b25c-1a51-4ab8-a563-1daecbbfddc6.jpg"
              }
            ]
          }
        ]
      }
    ]
  }
];

export default catalogue;
